import { Auth } from 'aws-amplify';

import GuestBase from '../views/Guest/Layout.vue';

import SignIn from '../views/Guest/Auth/SignIn.vue';
import SignUp from '../views/Guest/Auth/SignUp.vue';
import ConfirmSignUp from '../views/Guest/Auth/ConfirmSignUp.vue';
import CompleteNewPassword from '../views/Guest/Auth/CompleteNewPassword.vue';
// import ResendSignUp from '../views/Guest/Auth/ResendSignUp.vue';
// import ForgotPasswordSubmit from '../views/Guest/Auth/ForgotPasswordSubmit.vue';
import ForgotPassword from '../views/Guest/Auth/ForgotPassword.vue';


function loggedOut(to: any, from: any, next: any) {
    Auth.currentAuthenticatedUser().then(() => {
        next({ name: 'UserBase' });
    }).catch(() => {
        next();
    });
}

export default [
    {
        path: '/',
        name: 'GuestBase',
        component: GuestBase,
        beforeEnter: loggedOut,
        redirect: { name: 'SignIn' },
        children: [
            {
                path: 'signIn',
                name: 'SignIn',
                component: SignIn,
            },
            {
                path: 'signUp',
                name: 'SignUp',
                component: SignUp,
            },
            {
                path: 'confirmSignUp',
                name: 'ConfirmSignUp',
                component: ConfirmSignUp,
            },
            {
                path: 'completeNewPassword',
                name: 'CompleteNewPassword',
                component: CompleteNewPassword,
            },
            // {
            //     path: 'resendSignUp',
            //     name: 'ResendSignUp',
            //     component: ResendSignUp,
            // },
            // {
            //     path: 'forgotPasswordSubmit',
            //     name: 'ForgotPasswordSubmit',
            //     component: ForgotPasswordSubmit,
            // },
            {
                path: 'forgotPassword',
                name: 'ForgotPassword',
                component: ForgotPassword,
            },
        ],
    },
];
